import React, { useState } from 'react';

interface SetSymbolProps {
  setCode?: string | null;
  setName?: string | null;
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
}

/**
 * Displays a set symbol from Scryfall's set symbol API
 * Shows the iconic MTG set symbol alongside the set name
 */
export const SetSymbol: React.FC<SetSymbolProps> = ({ setCode, setName, size = 'md', style }) => {
  const [imageError, setImageError] = useState(false);

  // We need set code for the API - can't easily search by name
  if (!setCode || setCode.trim() === '') {
    // Just show the set name if we don't have the code
    return <span style={style}>{setName || 'Unknown Set'}</span>;
  }

  const sizeMap = {
    sm: { width: '20px', height: '20px' },
    md: { width: '24px', height: '24px' },
    lg: { width: '32px', height: '32px' },
  };

  const dimensions = sizeMap[size];

  // Scryfall set symbol API
  const symbolUrl = `https://svgs.scryfall.io/sets/${setCode.toLowerCase()}.svg`;

  if (imageError) {
    // Fallback: show set code in brackets
    return (
      <span style={style} title={setName || undefined}>
        [{setCode.toUpperCase()}]
      </span>
    );
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        ...style,
      }}
    >
      <img
        src={symbolUrl}
        alt={`${setName} symbol`}
        style={{
          ...dimensions,
          display: 'inline-block',
        }}
        onError={() => setImageError(true)}
        title={setName || setCode}
      />
      <span>{setName || setCode}</span>
    </div>
  );
};
